import { render, staticRenderFns } from "./Concussion1.vue?vue&type=template&id=05dd3284&scoped=true"
import script from "./Concussion1.vue?vue&type=script&lang=js"
export * from "./Concussion1.vue?vue&type=script&lang=js"
import style0 from "./Concussion1.vue?vue&type=style&index=0&id=05dd3284&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05dd3284",
  null
  
)

export default component.exports